/**
 * Pricing-card and payment-methods copy (Tier 14).
 *
 * Centralised here per AGENTS.md so the marketing pricing card and
 * the in-app billing surfaces share one English source of truth.
 * Currently scoped to the strings introduced when the multi-gateway
 * payments layer landed; existing pricing-card body copy still lives
 * inline in `LandingPage.tsx` (planned follow-up extraction).
 */

export const PRICING = {
  /** Heading shown above the accepted-method badge row. */
  acceptedPaymentMethodsLabel: 'Accepted payment methods',
  /** Tooltip body explaining the badge row. */
  acceptedPaymentMethodsTooltip:
    'Payment methods are determined by your operator-configured payment provider. Apple Pay and Google Pay are also accepted on supported browsers.',
  /** Provider id → display name. Used in the "Powered by ..." line under
   *  the badge row. */
  providerLabels: {
    stripe: 'Stripe',
    razorpay: 'Razorpay',
    paddle: 'Paddle',
    paypal: 'PayPal',
    lemonsqueezy: 'Lemon Squeezy',
    manual: 'Annual invoice',
  } as const,
  /** Human-readable label for each accepted-method id. */
  methodLabels: {
    card: 'Cards',
    visa: 'Visa',
    mastercard: 'Mastercard',
    amex: 'Amex',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    ach: 'ACH',
    sepa: 'SEPA',
    upi: 'UPI',
    netbanking: 'NetBanking',
    wallet: 'Wallets',
    paypal: 'PayPal',
    wire: 'Wire transfer',
    invoice: 'Invoice / PO',
  } as const,
  /** Suffix shown after the badge row: "Powered by Stripe", "Powered by Razorpay", etc. */
  poweredBy: (providerLabel: string): string => `Powered by ${providerLabel}`,
  /** Tooltip on the manual-invoice request CTA in the in-app billing page. */
  manualInvoiceCta: 'Request annual invoice',
} as const;

export type PricingKey = keyof typeof PRICING;
